const fmgPageValues = {
    VEHICLE: "vehicle",
    VEHICLE_DAMAGE: "vehicle-damage",
    ADDRESS_LOOKUP: "address-lookup",
    VIN_LOOKUP: "vin-lookup",
    VEHICLE_PARTS: "vehicle-parts",
    PART_QUESTIONS: "part-questions",
    MOLDING_QUESTIONS: "molding-questions",
    CAPABILITY_QUESTIONS: "capability-questions",
    LICENSE_PLATE_LOOKUP: "license-plate-lookup",
    ESTIMATE: "estimate",
    SERVICE_ZIP: "service-zip",
    ADDRESS_VEHICLES: "address-vehicles",
    QUOTE: "quote",
    INSURANCE_COMPANY: "insurance-company",
    INSURANCE_DETAILS: "insurance-details",
    SERVICE_LOCATION: "service-location",
    HERITAGE: "heritage",
    SCHEDULE: "schedule",
    CUSTOMER_DETAILS: "customer-details",
    PAYMENT_METHOD: "payment-method",
    PAYMENT: "payment",
    PAYMENT_PIA_RETURN: "payment-pia-return",
    CONFIRMATION: "confirmation",
    RETURN_USER: "return-user",
    EMAIL_SMS_PAGES: "email-or-sms-related-pages",
};

const funnelStartPageName = fmgPageValues.VEHICLE;
const returnUserPageName = fmgPageValues.RETURN_USER;

export { fmgPageValues, funnelStartPageName, returnUserPageName };
